export default __webpack_public_path__ + "static/media/membership-2.7e69688a.png";